export const sortFunc = (a, b, sortBy) => {
  let desc = 1;
  let asc = -1;
  if (typeof a[sortBy.value] === 'number') {
    return sortBy.descendingOrder ? b[sortBy.value] - a[sortBy.value] : a[sortBy.value] - b[sortBy.value];
  }
  if (String(a[sortBy.value]).toLowerCase() > String(b[sortBy.value]).toLowerCase()) {
    return sortBy.descendingOrder
      ? sortBy.value === 'createdAt'
        ? asc
        : desc
      : sortBy.value === 'createdAt'
        ? desc
        : asc;
  }
  if (String(a[sortBy.value]).toLowerCase() < String(b[sortBy.value]).toLowerCase()) {
    return sortBy.descendingOrder
      ? sortBy.value === 'createdAt'
        ? desc
        : asc
      : sortBy.value === 'createdAt'
        ? asc
        : desc;
  }
  return 0;
};
